// src/config/config.js
const config = {
    autoRefreshInterval: 300000, // Auto-refresh interval in milliseconds (2 minutes)
    apiUrl: process.env.REACT_APP_API_URL, // You can also define other configs like API URL here
  };
  
  export default config;
  